module.exports = __webpack_public_path__ + "img/BS06.7c8b57de.svg";